import { useWorkspace } from '@/features/workspaces/hooks';
import { IconButton } from '@/lib';
import { TranslationKeys } from '@/localization';
import { DataSource } from '@/models/dataSource';
import { useLazyGetDataSourceDependenciesQuery } from '@/services/dataSources';
import { FC, useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';

import ThreshIcon from '@/assets/icons/delete.svg?react';
import { Tooltip } from '@/components/tooltips';
import { isEmpty } from 'lodash';
import { DeleteDataSourceModal } from '../dataSourceDetails/components/tabs/settings/modals';

type DataSourceDeleteButtonProps = {
  datasource: DataSource;
  buttonText?: TranslationKeys;
  showTooltip?: boolean;
};

export const DataSourceDeleteButton: FC<DataSourceDeleteButtonProps> = ({ datasource, buttonText, showTooltip = false }) => {
  const { t } = useTranslation();
  const workspace = useWorkspace();

  const [getDataSourceDependencies, { data }] = useLazyGetDataSourceDependenciesQuery();

  useEffect(() => {
    if (datasource.id) {
      getDataSourceDependencies({
        workspaceId: workspace.id,
        dataSourceId: datasource.id,
      });
    }
  }, [datasource]);

  const disableDeleteButton = !data?.audiences || !isEmpty(data?.audiences);
  const tooltipContent = showTooltip && disableDeleteButton ? t('ALL:data_sources.cannotDeleteDataSource') : '';

  const [isModalOpen, toggleModal] = useReducer((state) => !state, false);

  return (
    <>
      <Tooltip tooltipContent={tooltipContent}>
        <IconButton
          intent='link-grey'
          className='!p-1.5 text-tertiary-600'
          text={t(buttonText as any)}
          leadingIcon={<ThreshIcon className='text-quaternary-400' />}
          onClick={toggleModal}
          disabled={disableDeleteButton}
        />
      </Tooltip>
      {isModalOpen && <DeleteDataSourceModal datasource={datasource} closeModal={toggleModal} />}
    </>
  );
};
